import { useState } from 'react';
import { startRegistration } from '@simplewebauthn/browser';
import { api } from '../lib/api';

interface Props {
  onDone: () => Promise<void> | void;
  onCancel: () => void;
}

export function Enroll({ onDone, onCancel }: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function enroll() {
    setBusy(true);
    setError(null);
    try {
      const optionsJSON = await api.registerBegin();
      const response = await startRegistration({ optionsJSON });
      await api.registerFinish(response);
      await onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Passkey setup failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="center">
      <div className="card">
        <h1>Set up your passkey</h1>
        <p className="muted">
          Create a passkey to finish signing in. After this, your temporary password is
          retired and you sign in with the passkey only.
        </p>
        <button type="button" onClick={enroll} disabled={busy}>
          {busy ? 'Follow your device prompt…' : 'Create passkey'}
        </button>
        <button type="button" className="link" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        {error && <p className="error">{error}</p>}
      </div>
    </main>
  );
}
